module.exports = __webpack_public_path__ + "img/folder-gear.35f0a75f.svg";